import { Component, OnInit } from '@angular/core';

import { GlobalServices } from '../../shared/services/global.services';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  constructor(private globalService: GlobalServices) { }

  ngOnInit(): void {
    this.globalService.headerData$.next({
      headerTitle: 'Reports',
      showBackButton: false
    });
  }

}
